<div class="not-found-wrapper flex align-items-center justify-content-center min-h-screen p-4">
    <div class="not-found-container text-center">
        <!-- Animated 404 Icon -->
        <div class="not-found-icon-wrapper mb-5">
            <div class="not-found-icon-bg"></div>
            <i class="pi pi-exclamation-circle not-found-icon"></i>
        </div>

        <!-- Error Code with Animation -->
        <div class="error-code-wrapper mb-4">
            <span class="error-code">404</span>
        </div>

        <!-- Title -->
        <h1 class="text-5xl font-bold text-color mb-3">
            {{ 'notFound.title' | transloco }}
        </h1>

        <!-- Description -->
        <p class="text-xl text-color-secondary mb-5 line-height-3 max-w-30rem mx-auto">
            {{ 'notFound.description' | transloco }}
        </p>

        <!-- Action Buttons -->
        <div class="flex flex-column sm:flex-row gap-3 justify-content-center align-items-center">
            <p-button
                [label]="'notFound.goHome' | transloco"
                icon="pi pi-home"
                (onClick)="goHome()"
                styleClass="px-5">
            </p-button>
            
            <p-button
                [label]="'notFound.goBack' | transloco"
                icon="pi pi-arrow-left"
                (onClick)="goBack()"
                severity="secondary"
                [outlined]="true"
                styleClass="px-5">
            </p-button>
        </div>

        <!-- Decorative Elements -->
        <div class="decorative-dots">
            <span class="dot dot-1"></span>
            <span class="dot dot-2"></span>
            <span class="dot dot-3"></span>
            <span class="dot dot-4"></span>
        </div>
    </div>
</div>
